import http from "@/services/configService";

export default {
    
    obterConfiguracaoInicial: async () => {        
        const resp = await http.get('/Configuracoes/MatriculaOnline')
        return resp.data
    },
    
    obterConfiguracaoDetalhada: async (unidade) => {
        const resp = await http.get(`/Configuracoes/MatriculaOnline/${unidade}`)
        return resp.data
    }
}  
